import React from 'react';
interface TeamMemberProps {
  name: string;
  role: string;
  description: string;
  imageUrl: string;
}
function TeamMember({
  name,
  role,
  description,
  imageUrl
}: TeamMemberProps) {
  return <div className="flex flex-col items-center text-center group" data-id="element-256">
      <div className="w-40 h-40 mb-4 overflow-hidden rounded-full border-4 border-white shadow-md transition-transform duration-300 group-hover:scale-105" data-id="element-257">
        <img src={imageUrl} alt={name} className="w-full h-full object-cover" data-id="element-258" />
      </div>
      <h3 className="font-bold text-lg" data-id="element-259">{name}</h3>
      <p className="text-purple-700 font-medium mb-2" data-id="element-260">{role}</p>
      <p className="text-gray-600 text-sm max-w-xs" data-id="element-261">{description}</p>
    </div>;
}
export function TeamSection() {
  const teamMembers = [{
    name: 'Craig Barton',
    role: 'Chief Academic Officer',
    description: "Craig is the brain behind Eedi's pedagogy (as well as wonderful books, including 'How I wish I'd taught maths'), and builds and delivers CPD courses about effective maths pedagogy.",
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7oCbESpvPHkJh4A4GbfgUL/StaffCraig.png'
  }, {
    name: 'Dr. Bibi Groot',
    role: 'Director of Learning Sciences',
    description: 'Bibi leads the research design, ensuring every study is scientifically robust and generates actionable insights for teaching.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8goC7JGeDJC7W8L2QkgYoE/Bibi.png'
  }, {
    name: 'Rachel Kidson',
    role: 'Head of Learning Design',
    description: 'Rachel is in charge of supporting and coaching participating teachers to make the most of Eedi in their classrooms and teaching practice.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1ybm4ygntPqrkarFbGrbNf/Staff7._Rachel.png'
  }, {
    name: 'Harriet Walters',
    role: 'Engagement Lead',
    description: 'Harriet is your first point of contact, guiding your school through the application and onboarding for the programme.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vv9xKqx7936Kjpqo2tBJSZ/Harriet.png'
  }, {
    name: 'Anjali Nambiar',
    role: 'Research Coordinator',
    description: 'Anjali coordinates the research on the ground, supporting your school with pilots assessments and data analysis.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vtLFw9noXCRfJ1DDhvnqNj/Anjali_Headshot_BnW.jpg'
  }, {
    name: 'Chelsea Burdett',
    role: 'Customer Success Lead',
    description: 'Chelsea provides day-to-day technical support, helping your teachers integrate Eedi effectively into their classroom practice.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6qM7aY2NCkTQDvCSYLvDDA/Chelsea.png'
  }];
  return <section className="py-16 bg-white relative overflow-hidden" id="team" data-id="element-262">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-purple-100 rounded-bl-full opacity-30" data-id="element-263"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-100 rounded-tr-full opacity-30" data-id="element-264"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-265">
        <div className="text-center mb-12" data-id="element-266">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-267">Meet the Team</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto mb-6" data-id="element-268"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-269">
            Meet the core team dedicated to supporting your school throughout
            the programme. We're here to ensure your success every step of the
            way.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-5xl mx-auto" data-id="element-270">
          {teamMembers.map((member, index) => <TeamMember key={index} name={member.name} role={member.role} description={member.description} imageUrl={member.imageUrl} data-id="element-271" />)}
        </div>
      </div>
    </section>;
}